package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.pages.ProfilePageViewModel

@Composable
fun ProfilePageWebView(viewModel: ProfilePageViewModel) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.TopCenter
    ) {
        Box(modifier = Modifier.width(1080.dp)) {
            ProfilePageView(viewModel)
        }
    }
}
